import classNames from "classnames";
import styles from "./style.module.scss";

interface Props {
  item: QuestionaireCardOptions;
  isActive: boolean;
}

const SliderCard = ({ item, isActive }: Props) => {
  return (
    <div
      className={classNames(
        styles.cardContainer,
        isActive && styles.activeCardContainer
      )}
    >
      <div
        className={classNames("mb-10")}
        style={isActive ? { display: "none" } : {}}
      >
        <div className={classNames(styles.iconDiv2)}>
          <item.Icon />
        </div>
      </div>
      <h1 className={styles.title}>{item.title}</h1>
      <h1
        className={classNames(
          styles.description,
          !isActive && styles.inActiveDescription
        )}
      >
        {item.description}
      </h1>
      <div
        className={classNames(
          isActive ? styles.imageDiv : styles.inActiveImgDiv
        )}
      >
        <img src={item.image} alt="" />
        <div className={classNames(styles.iconDiv)}>
          <item.Icon />
        </div>
      </div>
    </div>
  );
};

export default SliderCard;
